var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('upload-btn',{ref:"uploadBtn",attrs:{"accept":_vm.allowedMimeTypes.join(','),"fixed-width":_vm.fixedWidth,"title":_vm.titleComputed,"no-title-update":_vm.noTitleUpdateComputed,"disabled":_vm.uploading || _vm.disabled},on:{"file-update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }